<div class="compare_bx">
  <div class="compare_top">
    <div class="d-flex justify-content-between mb-16">
      <div class="title flex-grow-1">
        <figure>
          <img
            [src]="offer.policyDetails.categoryDetails.categoryLogo || ''"
            alt=""
            class="img-fluid"
          />
        </figure>
        <div class="d-flex flex-column">
          <div class="company">
            <ng-container *ngIf="lngCode === 'en'">
              {{ offer.policyDetails.categoryDetails.categoryName }}
            </ng-container>
            <ng-container *ngIf="lngCode !== 'en'">
              {{ offer.policyDetails.categoryDetails.categoryNameInFrench }}
            </ng-container>
          </div>
          <div class="insurance-type">
            <span>{{ getInsuranceTypeLabel(offer.insuranceType) }}</span>
          </div>
        </div>
      </div>

      @if (showActions && canEdit) {
        <div
          class="d-flex justify-content-evenly flex-grow-1 align-items-center"
        >
          @if (showViewIcon) {
            <a
              class="d-flex"
              [routerLink]="['/proposal/view', offer.proposalId]"
            >
              <app-eye-icon
                height="20px"
                width="20px"
                color="var(--gray-500)"
              />
            </a>
          }
          @if (
            offer.proposalState !== 'POLICY_CREATED' &&
            offer.proposalState !== 'REJECTED'
          ) {
            <app-pen-icon
              class="clickable"
              height="20px"
              width="20px"
              color="var(--gray-500)"
              role="button"
              tabindex="0"
              (click)="editProposal.emit(offer)"
              (keydown.enter)="editProposal.emit(offer)"
              (keydown.space)="editProposal.emit(offer)"
            />
          }
          <ng-container
            *ngIf="offer.proposalState === ProposalState.PROPOSAL_SAVED"
          >
            <app-trash-icon
              class="clickable"
              height="20px"
              width="20px"
              color="var(--gray-500)"
              role="button"
              tabindex="0"
              (click)="deleteProposal.emit(offer.proposalId)"
              (keydown.enter)="deleteProposal.emit(offer.proposalId)"
              (keydown.space)="deleteProposal.emit(offer.proposalId)"
            />
            <app-send-icon
              class="clickable"
              height="20px"
              width="20px"
              color="var(--gray-500)"
              role="button"
              tabindex="0"
              (click)="sendProposal.emit(offer.proposalId)"
              (keydown.enter)="sendProposal.emit(offer.proposalId)"
              (keydown.space)="sendProposal.emit(offer.proposalId)"
            />
          </ng-container>
        </div>
      }
    </div>
    <div class="proposal-badges d-flex flex-wrap align-items-start gap-2">
      <span
        class="lty-badge {{
          offer.proposalState !== ProposalState.PROPOSAL_SAVED
            ? getProposalStateBadgeClass(offer.proposalState)
            : 'success'
        }}"
      >
        <app-send-icon
          height="12px"
          width="12px"
          *ngIf="offer.proposalState === ProposalState.OFFER_CREATED"
        />
        <app-save-icon
          height="12px"
          width="12px"
          *ngIf="offer.proposalState === ProposalState.PROPOSAL_SAVED"
        />
        {{ getProposalStateLabel(offer.proposalState) }}
      </span>
      @if (offer.policyDetails.recommended) {
        <span class="lty-badge primary" i18n>Offre recommandée</span>
      }
    </div>

    <div class="prt offerid">
      <div>
        <p i18n>Offer Number (OID)</p>
        <span>{{ offer.policyDetails.offerId }}</span>
      </div>
      <div>
        <p i18n>Start Date</p>
        <span>{{ offer.policyDetails.startDate | date }}</span>
      </div>
      <div>
        <p i18n>End Date</p>
        <span>{{ offer.policyDetails.endDate | date }}</span>
      </div>
    </div>
    <div class="prt price">
      <div class="monthly">
        <span>{{ getPeriodicityLabel(offer.policyDetails.periodicity) }}</span>
        <span class="amount">
          {{ offer.policyDetails.premiumAmount | currency: 'CHF' }}
        </span>
      </div>
      <div class="yearly">
        <span i18n>Annuelle</span>
        <span class="amount">
          {{ offer.policyDetails.totalAmount | currency: 'CHF' }}
        </span>
      </div>
    </div>

    @if (offer.policyDetails.productDetails.productList.length > 0) {
      <div class="prt">
        <div class="part-title" i18n>Couverture</div>
        <app-proposal-products
          [productDetailsList]="offer.policyDetails.productDetails.productList"
        />
      </div>
    }

    <div class="prt downld">
      <div class="part-title" i18n>Documents</div>
      <ul>
        <li
          *ngFor="
            let doc of offer.policyDetails.policyDocs;
            let idx = index;
            let count = count
          "
        >
          <button
            type="button"
            class="document-button clickable"
            (click)="viewDocument.emit(doc)"
          >
            <app-file-alternate-icon height="16px" width="16px" />
            <span>
              <ng-container i18n>Document offre</ng-container>
              <ng-container *ngIf="count > 1"> {{ idx + 1 }}</ng-container>
            </span>
          </button>
        </li>
        @if (offer?.policyDetails?.categoryDetails?.documents?.length > 0) {
          <li *ngFor="let doc of offer.policyDetails.categoryDetails.documents">
            <button
              type="button"
              class="document-button clickable"
              (click)="viewDocument.emit(doc.link)"
            >
              <app-file-alternate-icon height="16px" width="16px" />
              <span>{{ doc.documentName }}</span>
            </button>
          </li>
        }
      </ul>
      <div
        class="blankdiv"
        *ngIf="offer.policyDetails.policyDocs.length <= 2"
      ></div>
    </div>
    <div class="prt ftrs">
      <div class="part-title" i18n>Key Features</div>
      <div class="points" [innerHtml]="offer.policyDetails.keyFeatures"></div>
    </div>
    <div class="prt ftrs">
      <div class="part-title" i18n>Key Benefits</div>
      <div
        class="points"
        [innerHtml]="offer.policyDetails.productBenefits"
      ></div>
    </div>
    <ng-content />
  </div>
</div>
